import React, { createContext, useMemo, useState, useContext } from 'react';
import { vehicleContext } from '../VehicleProvider';
import useCTAUrl from '../../hooks/useCTAUrl';
import { VehicleDetails, VendorCTATypes, CTABag } from '../../types';

interface CtaProviderProps {
  children: React.ReactNode;
  tier3Ctas: VendorCTATypes;
}

export const CTAContext = createContext<CTABag>({} as CTABag);
const { Provider } = CTAContext;

const CTAProvider: React.FC<CtaProviderProps> = ({ children, tier3Ctas }) => {
  const [mutate, setMutate] = useState(false);

  const { vehicle } = useContext(vehicleContext);
  const { id, market } = (vehicle as VehicleDetails) ?? {};

  const {
    bookATestDriveUrl,
    contactDealerUrl,
    requestAQuoteUrl,
    howEDepositWorksUrl,
    paymentCalculatorUrl,
  } = useCTAUrl();

  const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
  const redirect = new URLSearchParams(locationSearch).get('redirect') ?? undefined;

  // Todo Fix Source & Mutation Source
  const source = 'VTP';
  const mutationSource = 'VTP';

  // const {
  //   status,
  //   activeOnlineSaleId,
  //   activeOnlineSaleStatus,
  //   activeOnlineSale,
  //   onlineSaleEligibility,
  //   loading: loadingSale,
  // } = useSaleDetails({ id, market, source, accessToken });

  // const { errorMessage: createSaleErrorMessage } = useCreateSale({
  //   mutate,
  //   id,
  //   market,
  //   mutationSource,
  //   redirect,
  // });

  const dataBag = useMemo(
    () => ({
      mutate,
      bookATestDriveUrl,
      requestAQuoteUrl,
      setMutate,
      redirect,
      contactDealerUrl,
      howEDepositWorksUrl,
      paymentCalculatorUrl,
      tier3Ctas,
    }),
    [
      mutate,
      bookATestDriveUrl,
      requestAQuoteUrl,
      setMutate,
      redirect,
      contactDealerUrl,
      howEDepositWorksUrl,
      paymentCalculatorUrl,
      tier3Ctas,
    ],
  );

  return <Provider value={dataBag}>{children}</Provider>;
};

export default CTAProvider;
